import { of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolAction } from '../symbol.action';

type IDependencies = IClientApiDependencySegment;

export const removeSymbolEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolAction.remove.started),
  mergeMap((params) => {
    const { symbolId } = params;
    return dependencies.api.deleteSymbol({ symbolId }).pipe(
      mergeMap(() =>
        of(SymbolAction.remove.done({ params })),
      ),
      catchApiError((error) =>
        of(
          SymbolAction.remove.failed({ params, error: null }),
          createApiErrorNotification(error),
        ),
      ),
    );
  }),
);
